module.exports = __webpack_public_path__ + "static/EnmTX_BosChimera_L_A_cl-2ea64df24da5b800d5a8a9ac88e4e944.gif";